// plugins/bridge.js
import {
	getCookie,
	l,
	lc,
	lm,
	lreplace
} from '@utils/toolbox.js';
export default {
	install: (app, options) => {
		app.config.globalProperties.$l = proxyL;
		app.config.globalProperties.$lc = proxyLc;
		app.config.globalProperties.$lm = proxyLm;
		app.config.globalProperties.$lreplace = proxyLreplace;
	}
};

const isInlineTranslationEnabled = !!getCookie('inlineTranslation');

const proxyL = isInlineTranslationEnabled ? key => `⟦i18n:${key}⟧` : l;
const proxyLc = isInlineTranslationEnabled ? (key, context) => `⟦i18n:${key}|context:${context}⟧` : lc;
const proxyLm = isInlineTranslationEnabled ? (key, count) => `⟦i18n:${key}|count:${count}⟧` : lm;
const proxyLreplace = isInlineTranslationEnabled ? (key, replace) => `⟦i18n:${key}|replace:${JSON.stringify(replace)}⟧` : lreplace;
